import { IconButton, Modal, Stack, Typography } from "@mui/material";
import { CheckCircleIcon, CloseIcon } from "../../../Components/Icons/Icons";
import { AppColors } from "../../../Utils/helper/AppColors";

export default function CampaignSuccessModal({ open, onClose }) {
    return (
        <Modal open={open}>
            <Stack
                position="absolute"
                top="50%"
                left="50%"
                sx={{
                    transform: 'translate(-50%, -50%)',
                    width: 624,
                    height: 312,
                    bgcolor: '#F6F8FA',
                    border: '1px solid #DEE2E4',
                    borderRadius: '16px',
                    boxShadow: 24,
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 4,
                    py: 3,
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: 12,
                        right: 12,
                        color: '#A3A3A3',
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Stack alignItems="center" justifyContent="center" mt={2} mb={3}>
                    <Stack
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: 80,
                            height: 80,
                            borderRadius: '50%',
                            backgroundColor: AppColors?.green || '#BDF2CD',
                            mb: 2,
                        }}
                    >
                        <CheckCircleIcon color={'#FFFFFF'} size={40} />
                    </Stack>
                    <Typography sx={{ mb: 1, fontFamily: 'Poppins', fontWeight: 600, fontSize: 20, lineHeight: '130%', color: '#000000' }}>
                        Campaign Created!
                    </Typography>
                    <Typography sx={{ mb: 1, fontFamily: 'Poppins', fontWeight: 400, fontSize: 16, lineHeight: '150%', color: '#000000' }}>
                        You’re all set. Your campaign is live and ready to go!
                    </Typography>
                </Stack>
            </Stack>
        </Modal>
    );
}